import type { UploadFile } from "antd"
import type { RcFile } from "antd/es/upload/interface"
import type { Dispatch, SetStateAction } from "react"

import i18n from "../i18n.ts"
import { validateFile } from "./file-validation.ts"

// Keep in sync with LEAD_ATTACHMENT_MAX_SIZE_MB in ezbuild_back's core/file_limits.py.
export const ATTACHMENT_MAX_SIZE_MB = 50

// Send emails an external invoice's newest file through SES's v1 API, which caps a message at 10 MB after base64.
export const INVOICE_EMAIL_ATTACHMENT_MAX_MB = 7

export const validateAttachmentUpload = (file: File) =>
  validateFile(file, {
    maxSize: ATTACHMENT_MAX_SIZE_MB,
    anyFormat: true,
    defaultResult: true,
    sizeMessage: i18n.t("files.upload.tooLarge", {
      name: file.name,
      size: ATTACHMENT_MAX_SIZE_MB
    })
  }) === true

export const stageAttachment =
  (setFileList: Dispatch<SetStateAction<UploadFile[]>>) => (file: RcFile) => {
    if (validateAttachmentUpload(file)) {
      setFileList((prev) => [
        ...prev,
        { uid: file.uid, name: file.name, originFileObj: file }
      ])
    }

    return false
  }
